// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';

/* Shared Settings V2 primitives: section rail (scroll-spy anchors),
   the one sticky save bar, and the label-left/control-right form row. */

export function FormRow({ label, help, children, value, mono }) {
  return (
    <div className="sv2-frow">
      <div>
        <div className="sv2-label">{label}</div>
        {help ? <div className="sv2-help">{help}</div> : null}
      </div>
      {children !== undefined ? (
        <div>{children}</div>
      ) : (
        <div className={`sv2-value ${mono ? 'mono' : ''}`} title={typeof value === 'string' ? value : undefined}>
          {value ?? '—'}
        </div>
      )}
    </div>
  );
}

export function SaveBar({ dirty, saving, onSave, onDiscard }) {
  if (!dirty) return null;
  return (
    <div className="sv2-savebar" role="status">
      <span className="sv2-savebar-note">Unsaved changes</span>
      <button className="sv2-btn primary" onClick={onSave} disabled={saving}>
        {saving ? 'Saving…' : 'Save'}
      </button>
      <button className="sv2-btn" onClick={onDiscard} disabled={saving}>
        Discard
      </button>
    </div>
  );
}

/* Section rail — in-page anchors, same URL. Click scrolls; scroll highlights.
   Rendered only when the page passes 3+ sections. */
export function SectionRail({ sections, containerRef }) {
  const [active, setActive] = useState(sections[0]?.id);
  const observerRef = useRef(null);

  useEffect(() => {
    const root = document;
    const targets = sections
      .map((s) => root.getElementById(`sv2-${s.id}`))
      .filter(Boolean);
    if (!targets.length) return undefined;
    observerRef.current?.disconnect();
    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id.replace('sv2-', ''));
      },
      { rootMargin: '-80px 0px -55% 0px', threshold: 0.01 }
    );
    targets.forEach((t) => obs.observe(t));
    observerRef.current = obs;
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections.map((s) => s.id).join(',')]);

  if (sections.length < 3) return null;

  return (
    <nav className="sv2-rail" aria-label="On this page">
      {sections.map((s) => (
        <button
          key={s.id}
          className={active === s.id ? 'active' : ''}
          onClick={() =>
            document.getElementById(`sv2-${s.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        >
          {s.label}
        </button>
      ))}
    </nav>
  );
}

export function Section({ id, title, sub, children }) {
  return (
    <section id={`sv2-${id}`} className="sv2-section">
      <h2>{title}</h2>
      {sub ? <p className="sv2-section-sub">{sub}</p> : null}
      {children}
    </section>
  );
}
